<template>
  <v-app-bar app :color="colors.PRIMARY" dark>
    <v-app-bar-title>
      <v-btn variant="text" @click="$router.push('/')" class="text-h6 text-white pa-0">
        1stopVAT Walmart Portal
      </v-btn>
    </v-app-bar-title>
    <v-spacer></v-spacer>

    <span class="text-subtitle-1 mr-4">{{ userName }}</span>

    <!-- user menu -->
    <v-menu offset-y>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props" class="ml-2">
          <v-avatar color="secondary" size="36">
            <v-icon>mdi-account</v-icon>
          </v-avatar>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="handleLogout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import { msalInstance } from '@/auth/msalInstance';
import { computed } from 'vue';

const router = useRouter();
const colors = {
  PRIMARY: '#714FE3'
};

// Get user's given name from MSAL account
const userName = computed(() => {
  const accounts = msalInstance.getAllAccounts();
  return accounts.length > 0 ? accounts[0].idTokenClaims?.given_name || '' : '';
});

// Define emits
const emit = defineEmits(['logout']);

const handleLogout = async () => {
  try {
    emit('logout');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};
</script>
